<template>
  <div>
    <OfflineIndicator />
    <aside v-if="access.requiresInstall && access.limitedAccess && $route.name !== 'Install'" class="pwa-limited-banner" dir="rtl">
      <span>نسخه محدود: امکانات حساب پس از نصب و اجرای برنامه در دسترس است.</span>
      <router-link to="/install">نصب برنامه</router-link>
    </aside>
    <router-view v-if="routeAllowed" />
    <PwaInstallPrompt v-else />
    <PwaUpdatePrompt />
  </div>
</template>

<script>
import PwaUpdatePrompt from './components/PwaUpdatePrompt.vue'
import PwaInstallPrompt from './components/PwaInstallPrompt.vue'
import OfflineIndicator from './components/OfflineIndicator.vue'
import { pwaInstallState } from './pwaInstall'
import { isPwaRouteAllowed, safeInstallReturnPath } from './utils/pwaAccess.mjs'

export default {
  name: 'App',
  components: {
    PwaUpdatePrompt,
    PwaInstallPrompt,
    OfflineIndicator
  },
  data () {
    return { access: pwaInstallState }
  },
  computed: {
    routeAllowed () {
      return isPwaRouteAllowed(this.$route, this.access)
    }
  },
  watch: {
    'access.requiresInstall' () {
      if (!this.routeAllowed) {
        this.$router.replace({ name: 'Install', query: { redirect: this.$route.fullPath } })
      } else if (!this.access.requiresInstall && this.$route.name === 'Install') {
        this.$router.replace(safeInstallReturnPath(this.$route.query.redirect) || '/')
      }
    }
  }
}
</script>

<style scoped>
.pwa-limited-banner { position: sticky; top: 0; z-index: 5000; display: flex; align-items: center; justify-content: space-between; gap: 12px; padding: 12px 16px; color: #1f2f4d; background: #eff6ff; font: 13px/1.8 'IRANSansXFaNum-Light', sans-serif; }
.pwa-limited-banner a { flex-shrink: 0; color: #3268bd; font-weight: 700; }
</style>
